import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SideBarContainer } from '../../styled-components/SideBar';

class SideBar extends Component {
  render() {
    const { visible, left, right, footerHeight, headerHeight, fixed } = this.props;
    return (
      <SideBarContainer
        footerHeight={footerHeight}
        headerHeight={headerHeight}
        left={left}
        right={right}
        fixed={fixed}
        className={visible ? 'visible' : 'hidden'}
      >
        {this.props.children}
      </SideBarContainer>
    );
  }
}

SideBar.defaultProps = {
  children: [],
  visible: true,
  left: false,
  right: false,
  footerHeight: '',
  headerHeight: '',
  fixed: false
};

SideBar.propTypes = {
  visible: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
  left: PropTypes.bool,
  right: PropTypes.bool,
  fixed: PropTypes.bool,
  footerHeight: PropTypes.string,
  headerHeight: PropTypes.string,
  viewPortSize: PropTypes.number.isRequired
};

const mapStateToProps = state => ({
  viewPortSize: state.app.viewPortSize
});

export default connect(mapStateToProps)(SideBar);



// WEBPACK FOOTER //
// ./app/components/SideBar/SideBar.js